export const professionValues = [
  {
    value: '1',
    name: 'General Pediatrician'
  },
  {
    value: '2',
    name: 'Pediatric Psychiatrist'
  },
  {
    value: '3',
    name: 'Pediatric Neuropsychologist'
  },
  {
    value: '4',
    name: 'Pediatric Psychologist'
  },
  {
    value: '5',
    name: 'Pediatric Occupational Therapist'
  },
  {
    value: '6',
    name: 'Pediatric Speech Therapist '
  },
  {
    value: '7',
    name: 'Other'
  }
]

export const findDoctorProfession = value => {
  const profession: any = professionValues.find(item => value === item.value)
  return profession.name
}



// WEBPACK FOOTER //
// ./src/services/doctorProfessions.ts